export default "__VITE_ASSET__e571db11__"